import {
    DomainInitPayload,
    PaymentHistoryItem,
} from '@sxm-de/dev-kits/web-sdk/types';
import { getDefaultBillingProfile } from '../helpers/get-default-billing-profile';
import { getBillingProfilePaymentHistory } from '../helpers/get-billing-profile-payment-history';

interface GetPaymentHistoryFnPayload {
    startDateTime: string;
    endDateTime: string;
}

export type GetPaymentHistoryFn = (
    payload: GetPaymentHistoryFnPayload,
) => Promise<PaymentHistoryItem[]>;

export function initGetPaymentHistoryFn({
    dependencies,
}: DomainInitPayload): GetPaymentHistoryFn {
    return async ({
        startDateTime,
        endDateTime,
    }: GetPaymentHistoryFnPayload) => {
        try {
            const { id: billingProfileId } =
                await getDefaultBillingProfile(dependencies);
            const { items } = await getBillingProfilePaymentHistory(
                { billingProfileId, startDateTime, endDateTime },
                dependencies,
            );
            return items;
        } catch (error: any) {
            /**
             * TODO:
             * Log error to error logger (not analytics).
             */
            throw new Error('SYSTEM');
        }
    };
}
